import { cx } from 'cvb';
import PropTypes from 'prop-types';
import React from 'react';
import { withDigitalData } from '../../../utils/DigitalDataContext';
import { useConnectTab } from './hooks/useConnectTab';
import { ConnectTabStyles } from './ConnectTab.style';

const ConnectTab = ({ tabData, variant, digitalData }) => {
  const hookData = useConnectTab({ tabData, variant, digitalData });

  if (!hookData.shouldRender) {
    return null;
  }

  const {
    processedTabData,
    handleSelectedTab,
    getTabHeaderClasses,
    getTabContentClasses,
    containerClasses,
    leftTabId,
    rightTabId,
  } = hookData;

  const { leftTab, rightTab } = processedTabData;

  return (
    <>
      <div className={containerClasses}>
        <button
          className={getTabHeaderClasses(leftTab.isActive)}
          onClick={() => handleSelectedTab(0)}
          type="button"
          id={leftTabId}
        >
          {leftTab.title}
        </button>
        <button
          className={getTabHeaderClasses(rightTab.isActive)}
          type="button"
          onClick={() => handleSelectedTab(1)}
          id={rightTabId}
        >
          {rightTab.title}
        </button>
      </div>
      <div className={cx(getTabContentClasses(leftTab.isActive))}>{leftTab.content()}</div>
      <div className={cx(getTabContentClasses(rightTab.isActive))}>{rightTab.content()}</div>
      <style jsx>{ConnectTabStyles}</style>
    </>
  );
};

ConnectTab.defaultProps = {
  tabData: [],
  variant: 'primary',
};

ConnectTab.propTypes = {
  tabData: PropTypes.arrayOf(PropTypes.object),
  variant: PropTypes.oneOf(['primary', 'secondary', 'rebranding']),
  digitalData: PropTypes.object.isRequired,
};

export default withDigitalData(ConnectTab);
